export const qrcodeConstants = {
	SCANIN: 'scanin',
	BOOK: 'book',
};

export const MODE_SCAN_IN = 'scan_in';
export const MODE_SCAN_OUT = 'scan_out';